import type {RgbColor, HsvColor} from './colorTypes';

/**
 * @name rgbToHsv
 * @description Converts an RGB object into an HSV object
 */
export const rgbToHsv = (rgb: RgbColor): HsvColor => {
  const r = rgb.r / 255;
  const g = rgb.g / 255;
  const b = rgb.b / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const v = max;
  const delta = max - min;
  s = max === 0 ? 0 : delta / max;
  if (max !== min) {
    switch (max) {
      case r:
        h = ((g - b) / delta + (g < b ? 6 : 0)) * 60;
        break;
      case g:
        h = ((b - r) / delta + 2) * 60;
        break;
      default:
        h = ((r - g) / delta + 4) * 60;
        break;
    }
  }
  return {
    h,
    s,
    v,
  };
};
